import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { MobileBookBar } from "@/components/MobileBookBar";
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import GalleryPage from "@/pages/GalleryPage";
import AboutPage from "@/pages/AboutPage";
import PoliciesPage from "@/pages/PoliciesPage";
import ContactPage from "@/pages/ContactPage";
import BookingPage from "@/pages/BookingPage";
import NotFoundPage from "@/pages/NotFoundPage";

const AppShell = () => (
  <>
    <Header />
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/gallery" element={<GalleryPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/policies" element={<PoliciesPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/book" element={<BookingPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
    <MobileBookBar />
    <Footer />
    <Toaster theme="dark" position="bottom-center" />
  </>
);

export default function App() {
  return <BrowserRouter><AppShell /></BrowserRouter>;
}
